import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import classNames from 'classnames';
import { Icon } from '../../../Icon/Icon.es.js';

const InputInlineIcon = ({ name, className, align = 'left', size, ...rest })=>{
    const iconClasses = useMemo(()=>{
        return classNames({
            [`align-${align ?? ''}`]: align
        }, 'input-icon', className);
    }, [
        align,
        className
    ]);
    return jsx("span", {
        className: iconClasses,
        ...rest,
        children: jsx(Icon, {
            name: name,
            size: size
        })
    });
};
InputInlineIcon.displayName = 'Input.Inline.Icon';

export { InputInlineIcon };
//# sourceMappingURL=Input.Inline.Icon.es.js.map
